import { createStructuredSelector } from "reselect";
import {
    BPM_PRODUCT,
    BPM_PRODUCT_SUCCESS,
    BPM_PRODUCT_ERROR,
    BPM_SUPPLIER,
    BPM_SUPPLIER_SUCCESS,
    BPM_SUPPLIER_ERROR,
    BPM_CATEGORY,
    BPM_CATEGORY_SUCCESS,
    BPM_CATEGORY_ERROR,
    BPM_COUNTRY,
    BPM_COUNTRY_SUCCESS,
    BPM_COUNTRY_ERROR,
    BPM_LIST,
    BPM_LIST_SUCCESS,
    BPM_LIST_ERROR,
    BPM_LIST_SEARCH_CHANGE,
    BPM_LIST_PAGE_SET,
    BPM_ADD_MODAL_SET,
    BPM_ADD_CHANGE_SET,
    BPM_ADD,
    BPM_ADD_SUCCESS,
    BPM_ADD_ERROR,
    BPM_EDIT_MODAL_SET,
    BPM_EDIT_CHANGE_SET,
    BPM_EDIT,
    BPM_EDIT_SUCCESS,
    BPM_EDIT_ERROR,
    BPM_UPLOAD_SET,
    BPM_UPLOAD_SET_SUCCESS,
    BPM_UPLOAD_SET_ERROR,
    BPM_UPLOAD_RESET,
    BPM_UPLOAD2_SET,
    BPM_UPLOAD2_SET_SUCCESS,
    BPM_UPLOAD2_SET_ERROR,
    BPM_UPLOAD2_RESET
} from "../../actions";

export const NAME = 'healthBPM';


export const BPMProduct = (data) => ({
    type: BPM_PRODUCT,
    payload: data
});

export const BPMProductSuccess = (data) => ({
    type: BPM_PRODUCT_SUCCESS,
    payload: data
});

export const BPMProductError = (error) => ({
    type: BPM_PRODUCT_ERROR,
    payload: error
});

export const BPMSupplier = (data) => ({
    type: BPM_SUPPLIER,
    payload: data
});

export const BPMSupplierSuccess = (data) => ({
    type: BPM_SUPPLIER_SUCCESS,
    payload: data
});

export const BPMSupplierError = (error) => ({
    type: BPM_SUPPLIER_ERROR,
    payload: error
});

export const BPMCategory = (data) => ({
    type: BPM_CATEGORY,
    payload: data
});

export const BPMCategorySuccess = (data) => ({
    type: BPM_CATEGORY_SUCCESS,
    payload: data
});

export const BPMCategoryError = (error) => ({
    type: BPM_CATEGORY_ERROR,
    payload: error
});

export const BPMCountry = (data) => ({
    type: BPM_COUNTRY,
    payload: data
});

export const BPMCountrySuccess = (data) => ({
    type: BPM_COUNTRY_SUCCESS,
    payload: data
});

export const BPMCountryError = (error) => ({
    type: BPM_COUNTRY_ERROR,
    payload: error
});

export const BPMList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: BPM_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const BPMListSuccess = (data) => ({
    type: BPM_LIST_SUCCESS,
    payload: data
});

export const BPMListError = (error) => ({
    type: BPM_LIST_ERROR,
    payload: error
});

export const BPMPageSet = (data) => ({
    type: BPM_LIST_PAGE_SET,
    payload: data
});

export const BPMSearchChange = (data) => ({
    type: BPM_LIST_SEARCH_CHANGE,
    payload: data
});

export const BPMAddModalSet = (data) => ({
    type: BPM_ADD_MODAL_SET,
    payload: data
});

export const BPMAddChangeSet = (data) => ({
    type: BPM_ADD_CHANGE_SET,
    payload: data
});

export const BPMAdd = (page, num_page, orderBy, filters, data) => ({
    type: BPM_ADD,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const BPMAddSuccess = (message) => ({
    type: BPM_ADD_SUCCESS,
    payload: message
});

export const BPMAddError = (error) => ({
    type: BPM_ADD_ERROR,
    payload: error
});


export const BPMEditModalSet = (data) => ({
    type: BPM_EDIT_MODAL_SET,
    payload: data
});

export const BPMEditChangeSet = (data) => ({
    type: BPM_EDIT_CHANGE_SET,
    payload: data
});

export const BPMEdit = (page, num_page, orderBy, filters, data) => ({
    type: BPM_EDIT,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const BPMEditSuccess = (message) => ({
    type: BPM_EDIT_SUCCESS,
    payload: message
});

export const BPMEditError = (error) => ({
    type: BPM_EDIT_ERROR,
    payload: error
});

export const BPMUploadSet = (file) => ({
    type: BPM_UPLOAD_SET,
    payload: { file },
});

export const BPMUploadSetSuccess = (items) => ({
    type: BPM_UPLOAD_SET_SUCCESS,
    payload: items,
});

export const BPMUploadSetError = (error) => ({
    type: BPM_UPLOAD_SET_ERROR,
    payload: error,
});

export const BPMUploadReset = () => ({
    type: BPM_UPLOAD_RESET
});


export const BPMUpload2Set = (file) => ({
    type: BPM_UPLOAD2_SET,
    payload: { file },
});

export const BPMUpload2SetSuccess = (items) => ({
    type: BPM_UPLOAD2_SET_SUCCESS,
    payload: items,
});

export const BPMUpload2SetError = (error) => ({
    type: BPM_UPLOAD2_SET_ERROR,
    payload: error,
});

export const BPMUpload2Reset = () => ({
    type: BPM_UPLOAD2_RESET
});

const healthBPM = (state) => state[NAME];

export const HealthBPMSelector = createStructuredSelector({
    healthBPM
})